import Sequelize from "sequelize";
import { defineModel as defineModelAction } from "./model.js";
import { defineAuditedModel as defineAuditedModelAction } from "./auditedModel.js";
import { DataTypes as DBDataTypes } from "./DataTypes.js";
import Version from "./Version.js";

let sequelize;
export let models = {};

Version.defaults = {
  prefix: "",
  suffix: "audit",
  attributePrefix: "rev",
  exclude: ["createdAt", "updatedAt", "created_at", "updated_at"],
  underscored: false,
};

export const open = async ({ database, user, password, options }) => {
  const versioningOptions = {
    ...options,
    define: options.define || {
      createdAt: "created_at",
      updatedAt: "updated_at",
    },
  };

  sequelize = new Sequelize(database, user, password, versioningOptions);
  return sequelize;
};

export const defineModel = (modelName, modelAttributes, options) => {
  if (!sequelize) {
    throw new Error("Sequelize is not initialized!");
  }

  const Model = defineModelAction(sequelize, Sequelize, Version)(
    modelName,
    modelAttributes,
    options
  );

  models[modelName] = Model;

  return Model;
};

export const defineAuditedModel = (
  userModel,
  modelName,
  modelAttributes,
  options
) => {
  if (!sequelize) {
    throw new Error("Sequelize is not initialized!");
  }

  if (!models[userModel] && !models.user) {
    throw new Error(`Model ${userModel || "user"} does not exist!`);
  }

  const UserModel = models[userModel] || models.user;

  const Model = defineAuditedModelAction(sequelize, Sequelize, Version)(
    modelName,
    modelAttributes,
    options
  );

  models[modelName] = Model;

  Model.belongsTo(UserModel, {
    foreignKey: "created_by",
    as: "created_by_fk",
  });

  Model.belongsTo(UserModel, {
    foreignKey: "updated_by",
    as: "updated_by_fk",
  });

  return Model;
};

export const defineRelationships = (relationships) => {
  relationships.forEach((relationship) => {
    const sourceModel = relationship.source;
    const targetModel = relationship.target;
    if (!models[sourceModel]) {
      throw new Error(`Model ${relationship.source} does not exist!`);
    }

    if (!models[targetModel]) {
      throw new Error(`Model ${relationship.target} does not exist!`);
    }

    console.log("sourceModel", models[sourceModel]);
    models[sourceModel][relationship.type](models[targetModel], {
      foreignKey: relationship.foreignKey,
      through: relationship.through,
      otherKey: relationship.otherKey,
      as: relationship.as,
    });
  });
};

export const getModel = (modelName) => {
  return models[modelName];
};

export const sync = async () => {
  await sequelize.sync();
};

export const close = async () => {
  await sequelize.close();
};

export const DataTypes = DBDataTypes;
